export const TITLE_COMMITMENT_LIEN_SOURCE = 'Title Commitment';

export interface LienRow {
  propertyLienId?: number;
  loanId?: number;
  taskId?: number;
  propertyId?: number | null;
  lienType?: string;
  madeTo?: string;
  madeBy?: string;
  originalAmount?: number;
  requiresPayoff?: boolean;
  recordedDate?: string;
  datedDate?: string;
  status?: string | null;
  sourceType?: string;
}

export interface TaxRecordRow {
  propertyAddress?: string | null;
  annualTaxAmount?: number | null;
  taxFrequency?: string | null;
  taxAmountByFrequency?: number | null;
  propertyId?: number | null;
  addressMatched?: boolean;
}

export interface FieldReviewRow {
  itemName?: string;
  itemDisplayName?: string;
  data?: string | number | null;
  expectedData?: string | number | null;
  needsRevisionFlag?: boolean;
}

export interface LoanPropertyOption {
  propertyId: number;
  fullAddress: string;
}
